<template>
    <v-app>
      <!--INDICA LA PÁGINA EN LA QUE SE ENCUETRA-->
        <v-card class="grlCardInfo">
      <v-breadcrumbs :items="obtRuta" class="grlClase">
        <template v-slot:item="{ item }">
          <v-breadcrumbs-item @click="insertarRuta(item.ruta)" :disabled="item.disabled">
            {{ item.text.toUpperCase() }}
          </v-breadcrumbs-item>
        </template>
      </v-breadcrumbs>
    </v-card>
    <!--IMAGEN Y TITULO DE LA PÁGINA-->
    <v-card>
      <v-img :src="imgTitle" class="grlCardImg">
        <div class="grlCardInfo">
            <h1 class="my-auto hidden-sm-and-down">Bolsa de Trabajo</h1>
        </div>
      </v-img>
    </v-card>
        <div class="gralMargenes" id="gralEspaciado">
            <hr>
            <div style="text-align: center;" class="mt-10">
                <v-card class="mx-auto" width="1000" elevation="10" style="cursor: pointer;">
                    <a v-bind:href="`${facebook}`" target="_blank">
                        <v-img :src="img" width="1000" height="400" class="white--text align-end">
                        </v-img>
                    </a>
                    <v-card-title>SIGUENOS EN FACEBOOK</v-card-title>
                </v-card>
            </div>
        </div>
    </v-app>
</template>
<script>

export default {
  data: () => ({
    img: require('../../assets/img/bolsa-de-trabajo.jpg'),
    imgTitle: require('../../assets/img/banner-OE.jpg'),
    facebook: 'https://www.facebook.com/UJEDFAZ',
    obtRuta: [
      {
        text: 'Inicio',
        disabled: false,
        ruta: '/',
      },
      {
        text: 'Vinculación',
        disabled: true,
        ruta: '/',
      },
      {
        text: 'Bolsa de Trabajo',
        disabled: true,
        ruta: '/',
      },
    ],
  }),
  methods: {
    insertarRuta(ruta) {
      this.$router.push(ruta);
    },
  },
};
</script>

